import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { Payable } from '../../../../../models/entities/payable';
import type { CheckPrintingDialogResult } from './check-printing-dialog.component';

@Injectable({ providedIn: 'root' })
export class CheckPrintingDialogStateService
{
    readonly open = signal(false);
    readonly payable = signal<Payable | null>(null);

    private _result$: Subject<CheckPrintingDialogResult | null> | null = null;

    ask(payable: Payable): Observable<CheckPrintingDialogResult | null> {
        this.answer(null);
        this._result$ = new Subject<CheckPrintingDialogResult | null>();
        this.payable.set(payable);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: CheckPrintingDialogResult | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
